import React, { useState } from 'react'

import { Header, Grid, Image, Button } from 'semantic-ui-react'

import ExternalLink from '../../components/common/ExternalLink'

import AwsIcon from '../../_images/marketplace-aws-icon.svg'
import DropboxIcon from '../../_images/marketplace-dropbox-icon.svg'
import Hootsuite from '../../_images/marketplace-hootsuite-icon.svg'
import Zapier from '../../_images/marketplace-zapier-icon.svg'

const Marketplaces = () => {
  const [showForm, setShowForm] = useState(false)

  return (
    <>
      <Header as="h3">Marketplaces - Coming Soon</Header>
      
      <div style={{ display: 'flex', gap: '4rem', margin: '2rem 0 3rem 0' }}>
        <Image src={AwsIcon} style={{ width: 64, height: 64, opacity: 0.4 }} />
        <Image src={DropboxIcon} style={{ width: 64, height: 64, opacity: 0.4 }} />
        <Image src={Hootsuite} style={{ width: 64, height: 64, opacity: 0.4 }} />
        <Image src={Zapier} style={{ width: 64, height: 64, opacity: 0.4 }} />
      </div>

      <Grid columns={1} verticalAlign="middle" stackable>
        <Grid.Column>
          <Button primary onClick={() => setShowForm(!showForm)}>
            Suggest an Integration
          </Button>
        </Grid.Column>

        <Grid.Column style={{ display: showForm ? 'block' : 'none' }}>
          <iframe title="Vloggi marketplace enquiry" src="https://vloggi.activehosted.com/f/53" width="100%" height="550" style={{ border: '1px solid #eeeeee', borderRadius: '10px' }}></iframe>
        </Grid.Column>

        <Grid.Column>
          <ExternalLink url="https://vloggi.com/docs/building-for-the-vloggi-integrations-marketplace/">Read more</ExternalLink>
        </Grid.Column>
      </Grid>
    </>
  )
}

export default Marketplaces
